import { DB, SQLBatchTuple } from ".";
import log from "../log";
import time from "../time";
import { User } from "./t_user";
const insert_sql = "insert or replace into t_label" +
    "(label, uid, name,namePY,namePYS,nick,nickPY,nickPYS,email,appkey,mainAppkey,avatar,remark,remarkPY,remarkPYS,ctime)" +
    "values(?, ? , ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)"
export async function label_insert(
    db: DB,
    labels: Label[]
): Promise<{ error: any }> {
    let err: any = null;
    let insertCnt: number = 0;
    let updateCnt: number = 0;
    const n = labels.length;
    const commands: SQLBatchTuple[] = []
    for (let i = 0; i < n; i++) {
        const label = fixLabel(labels[i]);
        const unixTime = time.toUnixMillSecond(time.now());
        const parms = [
            label.label, label.uid, label.name, label.namePY,
            label.namePYS, label.nick, label.nickPY, label.nickPYS, label.email,
            label.appkey, label.mainAppkey, label.avatar, label.remark, label.remarkPY,
            label.remarkPYS, unixTime
        ];
        commands.push([insert_sql,parms])
        // const r = await db.Execute(insert_sql, parms);
        // if (r.error) {
        //     err = r.error;
        //     continue;
        // }
        // if (r.insertId > 0) {
        //     insertCnt++;
        // }
        // if (r.rowsAffected > 0) {
        //     updateCnt += r.rowsAffected;
        // }
    }
    const r = await db.BatchExecute(commands);
    log.info("t_label succ", "插入:", r.rowsAffected, "修改:", updateCnt);
    return { error: err };
}

export async function qry_labels_all(db: DB): Promise<{ error?: any, labels?: LabelGroupedData[] }> {
    const sql = `SELECT * FROM t_label`
    const r = await db.Query(sql, [])
    if (r.data && r.data.length > 0) {
        const result = processLabels(r.data)
        return { labels: result }
    }

    return { error: r.error }
}
export async function qry_labels(db: DB, skip: number, pageSize: number, search?: string): Promise<{ error?: any, labels?: LabelGroupedData[] }> {
    let params = []
    let sql = `SELECT * FROM t_label LIMIT ?, ?`
    params = [skip, pageSize]
    if (search && search.length > 0) {
        sql = `SELECT * FROM t_label   WHERE label LIKE ? LIMIT ? OFFSET ?`;
        params = [`%${search}%`, pageSize, skip];
    }
    const r = await db.Query(sql, params)
    if (r.data && r.data.length > 0) {
        const result = processLabels(r.data)
        return { labels: result }
    }
    return { error: r.error }
}
export async function qry_labels_by_uid(db: DB, uid: number): Promise<{ error?: any, labels?: { label: string }[] }> {
    const sql = `SELECT label FROM t_label WHERE uid = ?`
    const r = await db.Query(sql, [uid])
    if (r.data && r.data.length > 0) {
        return { labels: r.data }
    }
    return { error: r.error, labels: [] }
}
export async function qry_label(db: DB, label: string): Promise<{ error?: any, labels?: { label: string }[] }> {
    const sql = `SELECT label FROM t_label WHERE label = ?`
    const r = await db.Query(sql, [label])
    if (r.data && r.data.length > 0) {
        return { labels: r.data }
    }
    return { error: r.error }
}
export function processLabels(labels: Label[]) {
    const groupedData: Record<string, LabelGroupedData> = {};
    for (let i = 0; i < labels.length; i++) {
        const item = labels[i]
        // 如果 groupedData 中还没有这个 label，先初始化
        if (!groupedData[item.label]) {
            groupedData[item.label] = {
                label: item.label,
                users: []
            };
        }
        // 添加用户信息到对应的 label 组
        if (item.uid > 0) {
            groupedData[item.label].users.push(item as any as User);
        }
    }
    // 返回格式化后的数组
    return Object.values(groupedData);
}

//删除好友时，删除所有label中的该用户
export async function delLabelByUid(db: DB, uid: number): Promise<{ error?: any }> {
    let err: any = null;
    const sql = `DELETE FROM t_label WHERE uid = ?`
    const r = await db.Execute(sql, [uid])
    return { error: err }
}

export async function updateUser(db: DB, user: User) {
    // let sql = `UPDATE t_label SET  name = '${user.name || ''}',  namePY = '${user.namePY || ''}',  namePYS = '${user.namePYS || ''}', 
    //  nick = '${user.nick || ''}', nickPY = '${user.nickPY || ''}',  nickPYS = '${user.nickPYS || ''}',  email = '${user.email || ''}',
    // appkey = '${user.appkey || ''}', mainAppkey = '${user.mainAppkey || ''}', avatar = '${user.avatar || ''}', remark = '${user.remark || ''}',  
    // remarkPY = '${user.remarkPY || ''}', remarkPYS = '${user.remarkPYS || ''}'  WHERE uid = ${user.uid};`
    let sql = `
  UPDATE t_label SET 
    name = ?, 
    namePY = ?, 
    namePYS = ?, 
    nick = ?, 
    nickPY = ?, 
    nickPYS = ?, 
    email = ?, 
    appkey = ?, 
    mainAppkey = ?, 
    avatar = ?, 
    remark = ?, 
    remarkPY = ?, 
    remarkPYS = ?
  WHERE uid = ?;
`;

    const params = [
        user.name || '',
        user.namePY || '',
        user.namePYS || '',
        user.nick || '',
        user.nickPY || '',
        user.nickPYS || '',
        user.email || '',
        user.appkey || '',
        user.mainAppkey || '',
        user.avatar || '',
        user.remark || '',
        user.remarkPY || '',
        user.remarkPYS || '',
        user.uid,
    ];
    return await db.Execute(sql, params);

    // return await db.Execute(sql, [])
}

export async function updateLabelRemark(db: DB, uid: number, remark: string) {
    let sql = `UPDATE t_label SET  remark = ? WHERE uid = ?`
    return await db.Execute(sql, [remark || '', uid])
}


export async function updateLabelAvatar(db: DB, uid: number, avatar: string) {
    let sql = `UPDATE t_label SET avatar = ? WHERE uid = ?`
    return await db.Execute(sql, [avatar || '', uid])
}

export async function del_label_uids(db: DB, label: string, uids: number[]): Promise<{ error?: any }> {
    let err: any = null;
    let insertCnt: number = 0;
    let updateCnt: number = 0;
    const n = uids.length;
    for (let i = 0; i < n; i++) {
        const uid = uids[i]
        const sql = `DELETE FROM t_label WHERE uid = ? and label = ?`
        const r = await db.Execute(sql, [uid, label])
        if (r.error) {
            err = r.error;
            continue;
        }
        if (r.insertId > 0) {
            insertCnt++;
        }
        if (r.rowsAffected > 0) {
            updateCnt += r.rowsAffected;
        }
    }

    const sql = `SELECT COUNT(*) AS total FROM t_label WHERE label = ?`
    const r1 = await db.Query(sql, [label])
    if (r1.data && r1.data.length > 0) {
        const b = r1.data[0]?.total === 0
        if (b) {
            const data = defaultLabelDao
            data.label = label
            await label_insert(db, [data])
        }
    }
    return { error: err }
}
export async function del_label(db: DB, label: string): Promise<{ error?: any }> {
    const sql = `DELETE FROM t_label WHERE label = ?`
    return await db.Execute(sql, [label])
}

export async function update_label(db: DB, oldLabel: string, newLabel: string): Promise<{ error?: any }> {
    const sql = `UPDATE t_label SET label = ? WHERE label = ?`
    return await db.Execute(sql, [newLabel, oldLabel])
}


export type Label = {
    label: string,
    uid: number,
    name: string,
    namePY: string,
    namePYS: string,
    nick: string,
    nickPY: string,
    nickPYS: string,
    email: string,
    appkey: string,
    mainAppkey: string,
    avatar: string,
    remark: string,
    remarkPY: string,
    remarkPYS: string,
    ctime: number
}
export interface LabelGroupedData {
    label: string;
    users: User[];
}


function fixLabel(dao: Label): Label {
    return Object.assign({}, defaultLabelDao, dao);
}

const defaultLabelDao: Label = {
    label: "",
    uid: 0,
    name: "",
    namePY: "",
    namePYS: "",
    nick: "",
    nickPY: "",
    nickPYS: "",
    email: "",
    appkey: "",
    mainAppkey: "",
    avatar: "",
    remark: "",
    remarkPY: "",
    remarkPYS: "",
    ctime: 0,
};
